// extracted by mini-css-extract-plugin
export var paginationContainer = "_1x-0";